import React from "react";

const ZoomboxHeader = () => {
  return <div></div>;
};

export default ZoomboxHeader;
